import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

const APIROOT = process.env.REACT_APP_API_ENDPOINT;
// const APIROOT = 'http://127.0.0.1:8000/v1';
// const APIROOT = 'https://bhco.network.magnify-app.com/api/v1'

export function useFetch(endpoint, dependencies = []) {
  const apiToken = useSelector((state) => state.user.bearer);
  const apiRoot = APIROOT;
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);

  useMemo(() => {
    if (endpoint === undefined) {
      return undefined;
    }
    const fetchData = async () => {
      if (apiToken && apiRoot) {
        setIsPending(true);
        try {
          const response = await fetch(`${apiRoot}${endpoint}`, {
            method: "GET",
            headers: { authorization: apiToken },
          });
          if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
          }
          const dataResp = await response.json();
          setIsPending(false);
          setData(dataResp);
          setError(null);
        } catch (error) {
          setError(`${error} Could not fetch data from ${endpoint}`);
          setIsPending(false)
          console.error("Failed to fetch data:", error);
        }
      }
    };
    // console.log("Fetching data...");
    fetchData();
  }, [apiToken, apiRoot, endpoint, ...dependencies]);
  return { data, isPending, error}
}

export function sendData(endpoint, postData, apiToken, method = "POST") {
  // const apiToken = useSelector((state) => state.user.bearer);
  const apiRoot = APIROOT;

    if (endpoint === undefined) {
      return undefined;
    }
    const fetchData = async () => {
      if (apiToken && apiRoot) {
        // setIsPending(true);
        console.log("postData", postData);
        try {
          const response = await fetch(`${apiRoot}${endpoint}`, {
            method: method,
            headers: { 
              authorization: apiToken,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData)
          });
          if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
          }
          const dataResp = await response.json();
          return dataResp;
          // setIsPending(false);
          // setData(dataResp);
          // setError(null);
        } catch (error) {
          // setError(`${error} Could not send data to ${endpoint}`);
          // setIsPending(false)
          console.error("Failed to send data:", error);
        }
      } else {console.log(`No API token or API root`);}
    };
    // console.log("Fetching data...");
    return fetchData();
  // }, [apiToken, apiRoot, endpoint]);
  // return { data, isPending, error}
}

// const useAssessmentDataLoader = (department, level) => {
//   console.log("department", department);
//   console.log("level", level);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [data, setData] = useState({
//     currentLevelFields: [],
//     nextLevelFields: [],
//     nextLevel: null
//   });

//   // const reviewAssessmentData  = useFetch(`/people/assessments/annual/competencies/questions/${department}/${level}`);
//   // console.log("reviewAssessmentData", reviewAssessmentData);

//   // Extract the actual data arrays from the JSON files
//   const levelOrderArray = useMemo(() => {
//     const key = Object.keys(levelOrderData)[0];
//     return levelOrderData[key] || [];
//   }, []);

//   const assessmentFieldsArray = useMemo(() => {
//     const key = Object.keys(assessmentFieldsData)[0];
//     return assessmentFieldsData[key] || [];
//   }, []);

//   // Find the next level based on sort_order
//   const getNextLevel = useMemo(() => {
//     if (!department || !level) return null;

//     // Find current level entry
//     const currentLevelEntry = levelOrderArray.find(
//       entry => entry.DEPARTMENT === department && 
//                entry.LEVEL === level && 
//                entry.ACTIVE === true
//     );

//     if (!currentLevelEntry) return null;

//     // Find the next level (sort_order + 1)
//     const nextLevelEntry = levelOrderArray.find(
//       entry => entry.DEPARTMENT === department && 
//                entry.SORT_ORDER === currentLevelEntry.SORT_ORDER + 1 && 
//                entry.ACTIVE === true
//     );

//     return nextLevelEntry ? nextLevelEntry.LEVEL : null;
//   }, [department, level, levelOrderArray]);

//   useEffect(() => {

//     const loadData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         if (!department || !level) {
//           setData({
//             currentLevelFields: [],
//             nextLevelFields: [],
//             nextLevel: null
//           });
//           return;
//         }

//         // Filter assessment fields for current level
//         const currentLevelFields = assessmentFieldsArray.filter(
//           field => field.DEPARTMENT === department && 
//                    field.LEVEL === level && 
//                    field.ACTIVE === true
//         );

//         // Filter assessment fields for next level
//         const nextLevelFields = getNextLevel 
//           ? assessmentFieldsArray.filter(
//               field => field.DEPARTMENT === department && 
//                        field.LEVEL === getNextLevel && 
//                        field.ACTIVE === true
//             )
//           : [];

//         setData({
//           currentLevelFields: currentLevelFields.sort((a, b) => a.SORT_ORDER - b.SORT_ORDER),
//           nextLevelFields: nextLevelFields.sort((a, b) => a.SORT_ORDER - b.SORT_ORDER),
//           nextLevel: getNextLevel
//         });

//       } catch (err) {
//         setError(err.message);
//         setData({
//           currentLevelFields: [],
//           nextLevelFields: [],
//           nextLevel: null
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadData();
//   }, [department, level, getNextLevel, assessmentFieldsArray]);

//   return {
//     loading,
//     error,
//     data,
//     // Helper methods
//     getCurrentLevelFields: () => data.currentLevelFields,
//     getNextLevelFields: () => data.nextLevelFields,
//     getNextLevel: () => data.nextLevel,
//     hasNextLevel: () => !!data.nextLevel
//   };
// };

// export default useAssessmentDataLoader;
